


































































































































import { Component, Vue, Watch, Ref } from "vue-property-decorator";
import PrestadorAutocomplete from "@/components/saude/PrestadorAutocomplete.vue";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { PaginationModel } from "@/models/commons/PaginationModel";
import { PrestadorModel } from "@/models/cadastros/assistencia/PrestadorModel";
import { PrestadorResumidoModel } from "@/models/cadastros/saude/PrestadorResumidoModel";
import { cadastroPrestadorService } from "@/service/cadastro/saude/CadastroPrestadorService";
import EspecialidadeModel from "@/models/cadastros/saude/EspecialidadeModel";
import { ValidationObserver } from "vee-validate";
import { cadastroAgendaService } from "@/service/cadastro/saude/agenda/CadastroAgendaService";
import { ConfiguracaoAgendaPrestadorPaginationModel } from '@/models/cadastros/saude/ConfiguracaoAgendaPrestadorPaginationModel';
import { CadastroAgendaPrestadorResumidoModel } from '@/models/cadastros/saude/CadastroAgendaPrestadorResumidoModel';

@Component({
  components: {
    PrestadorAutocomplete,
    GsModalDialog
  },
})
export default class ListaConfiguracaoAgendaPrestador extends Vue {
  @Ref()
  filtroObserver!: InstanceType<typeof ValidationObserver>;

  prestador = "";
  especialidade = "";
  loadingFiltrar = false;
  loading = false;
  prestadorSelecionado: PrestadorModel = {
    flagCadastroCPOM: false,
    contaBancaria: { contaPrincipal: false },
  };
  prestadores = [];
  especialidadesPrestador: EspecialidadeModel[] = [];
  especialidadesFiltrada: EspecialidadeModel[] = [];
  especialidadeSelecionada: EspecialidadeModel = {};
  nomeEspecialidade = "";
  loadingEspecialidades = false;
  configuracaoesAgendaPrestador: CadastroAgendaPrestadorResumidoModel[] = [];

  cabecalho = [
    { text: "Prestador", value: "nomePrestador", sortable: false, width: "30%" },
    { text: "Especialidade", value: "nomeEspecialidade", sortable: false },
    { text: "Duração", value: "duracaoAtendimento", sortable: false, width: "30%" },
    { text: "Ações", value: "actions", sortable: false, width: "10%" },
  ];
  options: PaginationModel = {
    page: 1,
    itemsPerPage: 5,
    itemsLength: 0,
  };

  configuracaoExclusao = {} as CadastroAgendaPrestadorResumidoModel;
  confirmacaoExclusao = false;
  mensagem = "";
  title = "";
  confirmacao = false;

  @Watch("nomeEspecialidade")
  filtrarEspecialidade(val: string) {
    this.especialidadesFiltrada = this.especialidadesPrestador.filter(
      (especialidade) => {
        if (
          especialidade.nome &&
          especialidade.nome.toLowerCase().includes((val || "").toLowerCase())
        ) {
          return especialidade;
        }
      }
    );
  }

  @Watch("prestadorSelecionado")
  selecionarPrestador(val: PrestadorResumidoModel) {
    cadastroPrestadorService.obterPrestador(val.id).then((res) => {
      res.especialidadesPrestador.forEach((especialidadePrestador) => {
        if (especialidadePrestador.especialidade) {
          if (
            this.especialidadesPrestador.findIndex(
              (e) =>
                especialidadePrestador.especialidade &&
                e.id == especialidadePrestador.especialidade?.id
            ) < 0
          ) {
            this.especialidadesPrestador.push(
              especialidadePrestador.especialidade
            );
          }
        }
      });
    });
  }

  filtrar() {
    if (!this.prestadorSelecionado || !this.prestadorSelecionado.id) {
      this.filtroObserver.setErrors({
        Prestador: "O campo Prestador é obrigatório",
      });
      return;
    }
    cadastroAgendaService.consultarAgendaPrestador(
      this.options,
      this.prestadorSelecionado.id,
      this.especialidadeSelecionada.id
    )
    .then((res: ConfiguracaoAgendaPrestadorPaginationModel) => {
      this.options.itemsLength = res.itemsLength;
      this.configuracaoesAgendaPrestador = res.conteudo;
    })
    ;
  }

  solicitarExclusao(configuracao: CadastroAgendaPrestadorResumidoModel) {
    this.mensagem = `Confirma a exclusão da agenda do prestador ${configuracao.nomePrestador} para a especialidade ${configuracao.nomeEspecialidade}?`;
    this.title = "Confirma exclusão?";
    this.confirmacaoExclusao = true;
    this.configuracaoExclusao = configuracao;
    this.confirmacao = true;
  }

  cancelarExclusao() {
    this.mensagem = "";
    this.title = "";
    this.confirmacaoExclusao = false;
    this.configuracaoExclusao = {} as CadastroAgendaPrestadorResumidoModel;
  }

  confirmarExclusao() {
    this.confirmacaoExclusao = false;
    cadastroAgendaService.excluirConfiguracaoAgendPrestadorEspecialidade(this.configuracaoExclusao.id)
    .then(() => {
      this.title = "Sucesso";
      this.mensagem = `Exclusão da configuração da agenda do prestador ${this.configuracaoExclusao.nomePrestador} para a especialidade ${this.configuracaoExclusao.nomeEspecialidade} efetuada com sucesso.`;
    })
    .catch(() => {
      this.title = "Erro";
      this.mensagem = `Ocorreu um erro ao excluir a configuração da agenda do prestador ${this.configuracaoExclusao.nomePrestador} para a especialidade ${this.configuracaoExclusao.nomeEspecialidade}.`;
    })
    .finally(() => {
      this.confirmacao = false;
      this.confirmacaoExclusao = true;
    })
  }

  fecharMensagem() {
    this.mensagem = "";
    this.title = "";
    this.confirmacaoExclusao = false;
    this.configuracaoExclusao = {} as CadastroAgendaPrestadorResumidoModel;
    this.filtrar();
  }
}
